function getEmbedID(youtubeUrl) {
    let embedID = ""
    let coverVideoEmbed = null
    if (embedID = youtubeUrl.match(/(\?|&)v=([^&#]+)/)) {

        coverVideoEmbed = embedID.pop();

    } else if (embedID = youtubeUrl.match(/(\.be\/)+([^\/?]+)/)) {

        coverVideoEmbed = embedID.pop();

    } else if (embedID = youtubeUrl.match(/(\embed\/)+([^\/]+)/)) {

        coverVideoEmbed = (embedID.pop().replace('?rel=0',''));

    }

    return coverVideoEmbed
}

export default { getEmbedID }